import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client' for React 18
import App from './App';
import { AuthProvider } from './scripts/AuthContext'; // Import the AuthProvider

// Get the root element in your HTML (usually <div id="root"></div>)
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app using createRoot
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
